import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import config from 'configs/app';
import SeoListPageShell from 'ui/shared/seo/SeoListPageShell';

const Blocks = dynamic(() => import('ui/pages/Blocks'), { ssr: false });

const Page: NextPage = () => {
  const title = config.meta.seo.enhancedDataEnabled ?
    `${ config.chain.name } blocks` :
    'Blocks';

  return (
    <SeoListPageShell pathname="/blocks" title={ title }>
      <Blocks hideTitle/>
    </SeoListPageShell>
  );
};

export default Page;
